import ReactDataSheet from 'react-datasheet';
import { GridElement } from './types';
import RowRendererProps = ReactDataSheet.RowRendererProps;

export const DefaultRowRenderer: React.FC<RowRendererProps<GridElement>> = (prop) => {
  return <tr>{prop.children}</tr>;
};

export const DefaultValueViewer: React.FC<ReactDataSheet.ValueViewerProps<GridElement>> = (prop) => {
  return <span className="value-viewer">{prop.value}</span>;
};
